<script lang="ts">

    const modalType = ['loader', 'validation', 'error']
    type ModalType = typeof modalType[string];

    export let title: string;
    export let type: ModalType;
    export let message: string|null = null;

    function closeModal() {
        const modal = <HTMLDivElement>document.querySelector('.modal');
        modal.remove();
    }
</script>

<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="box modal-box-container is-flex is-justify-content-center is-flex-direction-column">
            <div class="content">
                {#if $$slots.button}
                    <slot name="button"></slot>
                {:else }
                    <button on:click={closeModal} class="modal-close is-large" aria-label="close"></button>
                {/if}
                <h3 class="has-text-centered title is-3 mt-0">{title}</h3>
                <div class="is-flex is-justify-content-center">
                    {#if type === 'loader'}
                        <div class="dots5">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    {:else if type === 'validation'}
                        <div class="loader-container">
                            <div class="success-checkmark">
                                <div class="check-icon">
                                    <span class="icon-line line-tip"></span>
                                    <span class="icon-line line-long"></span>
                                    <div class="icon-circle"></div>
                                    <div class="icon-fix"></div>
                                </div>
                            </div>
                            {#if $$slots.comment}
                                <slot name="comment"></slot>
                            {/if }
                            <div class="modal-button-container">
                                <slot name="buttons-container"></slot>
                            </div>
                        </div>
                    {:else }
                        <p class="has-text-weight-bold">{message}</p>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>